// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__QwD+f","inner":"Footer_inner__NB0X+","links":"Footer_links__vUbnJ"};